//
// Layout.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataRendererModel";
import "../annotation/AbstractAnnotation";
import "../layoutOverlay/AutoAlignPositions";
import "./styles/FillAttributes";
import "./styles/LineAttributes";
import "./HorizontalAlignment";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "./Pad";
import "./VerticalAlignment";
import "./GTLContent";

var Layout = createModule("gtl::Layout", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel"], EventDispatcher, [
    ,
    {
        border: 2,
        hAlign: 4,
        opaque: 2,
        annotations: [1],
        outerPad: 1,
        autoAlign: 1,
        backgroundAttributes: 1,
        vAlign: 4,
        pad: 1,
        width: 1,
        borderAttributes: 1,
        supplementalContents: [1],
        height: 1,
    },
    ,
    ,
    {
        needsX2Axis: [2],
        needsXAxis: [2],
        needsY2Axis: [2],
        needsYAxis: [2],
    },
    ,
    ,
]);
export default Layout;
